import { render, staticRenderFns } from "./index.vue?vue&type=template&id=482b8f0c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482b8f0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482b8f0c')) {
      api.createRecord('482b8f0c', component.options)
    } else {
      api.reload('482b8f0c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=482b8f0c&scoped=true&", function () {
      api.rerender('482b8f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/designSprint/index.vue"
export default component.exports